import { css } from '../../styles/theme';

export const StylesOVGB = css`
`;
